import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { partyFlow } from '@/mocks/jiuchou-business';

export default function PartyScene() {
  const [started, setStarted] = useState(false);
  const [active, setActive] = useState(0);

  if (!started) {
    return (
      <section className="w-full bg-background-50 py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <Reveal>
            <SectionHeading
              eyebrow="聚餐 · 消费场景"
              title="一场聚餐，跑通 AI、权益、餐饮、社交与数据"
              subtitle="从新人权益、发起聚餐、邀请好友，到到店消费、核销权益、评价与数据回流，完整演示一场数字消费体验。"
            />
          </Reveal>
          <Reveal delay={100}>
            <button
              onClick={() => setStarted(true)}
              className="mt-10 inline-flex items-center gap-3 px-10 py-4 rounded-full bg-accent-500 text-background-50 font-heading font-bold text-lg whitespace-nowrap cursor-pointer transition-all hover:bg-accent-600 hover:scale-[1.03]"
            >
              <i className="ri-restaurant-2-line text-2xl"></i>
              进入聚餐
            </button>
          </Reveal>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-wrap items-center gap-2">
          {partyFlow.map((s, i) => (
            <div key={s.label} className="flex items-center gap-2">
              <button
                onClick={() => setActive(i)}
                className={`px-4 py-2.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-all border ${
                  i === active
                    ? 'bg-accent-500 text-background-50 border-transparent font-semibold'
                    : 'bg-background-50 border-background-200 text-foreground-700 hover:border-accent-300'
                }`}
              >
                {s.label}
              </button>
              {i < partyFlow.length - 1 && (
                <i className="ri-arrow-right-line text-foreground-400 text-sm hidden sm:block"></i>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 p-6 rounded-lg bg-background-100 border border-background-200">
          <div className="flex items-center gap-2 font-heading font-bold text-foreground-950">
            <span className="w-6 h-6 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-xs">
              {active + 1}
            </span>
            {partyFlow[active].label}
          </div>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{partyFlow[active].detail}</p>
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => setStarted(false)}
            className="px-5 py-2 rounded-md border border-background-200 text-foreground-600 text-sm cursor-pointer hover:border-accent-300 hover:text-accent-600 transition-colors"
          >
            重新体验
          </button>
        </div>
      </div>
    </section>
  );
}